function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22 5a3 3 0 013 3v17H5V8a3 3 0 013-3h14z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M22 7H8a1 1 0 00-.993.883L7 8v15h16V8a1 1 0 00-.883-.993L22 7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 20h-7v-2h7zm-5.5-9.5l2.5 3.01L17.5 9l4.5 6H8z"
});

function SvgQImageWOpenResponseTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref, _ref2, _ref3);
}

export default SvgQImageWOpenResponseTypeIcon;